// if false, 👉️ You are on the server
// if true, 👉️ You are on the client
export const windowIsReady = typeof window !== 'undefined';
